import styled, { css } from 'styled-components'

type CardProps = {
  verticalAlign?: 'top' | 'bottom' | 'center'
  horizontalAlign?: 'left' | 'right' | 'center'
}

interface PositionOptions {
  vertical?: 'top' | 'bottom' | 'center'
  horizontal?: 'left' | 'right' | 'center'
}

const getPosition = ({
  vertical = 'bottom',
  horizontal = 'left',
}: PositionOptions): string => {
  const isTop = vertical === 'top'
  const isCenter = vertical === 'center'

  const isLeft = horizontal === 'left'
  const isRight = horizontal === 'right'

  if (isTop) {
    if (isLeft) return 'transform: translateY(-80%); right: 0;'
    if (isRight) return 'transform: translateY(-80%); left: 0;'
    return 'left: 50%; transform: translate(-50%, -80%);'
  }

  if (isCenter) {
    if (isLeft) return 'top: 50%; transform: translateY(-50%); right: 0;'
    if (isRight) return 'top: 50%; transform: translateY(-50%); left: 0;'
    return 'left: 50%; transform: translate(-50%, -50%);'
  }

  if (isLeft) return 'transform: translateY(80%); right: 0;'
  if (isRight) return 'transform: translateY(80%); left: 0;'
  return 'left: 50%; transform: translate(-50%, 80%);'
}

export const Card = styled.div<CardProps>`
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  background-color: ${(props) => `${props.theme.colors.black}4d`};
  box-shadow: 0px 0px 12px ${(props) => props.theme.colors.primary_1};

  display: flex;
  flex-direction: column;
  align-items: center;

  border-radius: 32px;
  gap: 24px;
  padding: 24px;

  width: max-content;

  position: absolute;
  ${(props) =>
    css`
      ${getPosition({
        vertical: props.verticalAlign,
        horizontal: props.horizontalAlign,
      })}
    `}
`
